"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchFilter = function (_React$Component) {
	_inherits(SearchFilter, _React$Component);

	function SearchFilter() {
		_classCallCheck(this, SearchFilter);

		return _possibleConstructorReturn(this, (SearchFilter.__proto__ || Object.getPrototypeOf(SearchFilter)).apply(this, arguments));
	}

	_createClass(SearchFilter, [{
		key: "render",
		value: function render() {

			return _react2.default.createElement(
				"div",
				{ className: "ip-searchFilter " + this.props.className },
				_react2.default.createElement(
					"label",
					{ className: "ip-label", htmlFor: "ip-filter-select" },
					this.props.title
				),
				_react2.default.createElement(
					"div",
					{ className: "ip-radioGroup ip-premiumFilter" },
					_react2.default.createElement("input", { type: "radio", id: "ip-premiumFilter-all", value: "all", onChange: this.props.handleFilter, checked: this.props.filter == 'all' ? 'checked' : false }),
					_react2.default.createElement(
						"label",
						{ htmlFor: "ip-premiumFilter-all" },
						iconPressConfig.translations.ALL
					),
					_react2.default.createElement("input", { type: "radio", id: "ip-premiumFilter-free", value: "0", onChange: this.props.handleFilter, checked: this.props.filter == '0' ? 'checked' : false }),
					_react2.default.createElement(
						"label",
						{ htmlFor: "ip-premiumFilter-free" },
						iconPressConfig.translations.FREE_ONLY
					),
					_react2.default.createElement("input", { type: "radio", id: "ip-premiumFilter-prm", value: "1", onChange: this.props.handleFilter, checked: this.props.filter == '1' ? 'checked' : false }),
					_react2.default.createElement(
						"label",
						{ htmlFor: "ip-premiumFilter-prm" },
						iconPressConfig.translations.PREMIUM_ONLY
					)
				)
			);
		}
	}]);

	return SearchFilter;
}(_react2.default.Component);

exports.default = SearchFilter;


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchFilter.js
// module id = 256
// module chunks = 0 1